import React from 'react';
import PropTypes from 'prop-types';

const Cta = ({
	contactInfo,
	mapLink,
	accountId,
	ctaPrefs,
	ctaLabels,
	isMobile
}) => {
	const {
		mapButtonStyle,
		mapButtonSize,
		mapButtonLayout,
		callButtonLayout,
		callButtonStyle,
		callButtonSize
	} = ctaPrefs;
	const { CALL, GET_DIRECTIONS } = ctaLabels;

	const mapButtonStyleClass = mapButtonStyle ? ` btn-${mapButtonStyle}` : '';
	const mapButtonSizeClass = mapButtonSize ? ` btn-${mapButtonSize}` : '';
	const mapButtonLayoutClass = mapButtonLayout ? ` ${mapButtonLayout}` : '';
	const mapButtonClasses = `btn${mapButtonStyleClass}${mapButtonLayoutClass}${mapButtonSizeClass}`;

	const callButtonStyleClass = callButtonStyle
		? ` btn-${callButtonStyle}`
		: '';
	const callButtonSizeClass = callButtonSize ? ` btn-${callButtonSize}` : '';
	const callButtonLayoutClass = callButtonLayout
		? ` ${callButtonLayout}`
		: '';
	const callButtonClasses = `btn${callButtonStyleClass}${callButtonLayoutClass}${callButtonSizeClass}`;

	const directionButton = mapLink ? (
		<div className="direction-link mb-4">
			<a
				className={mapButtonClasses}
				href={mapLink}
				target="_blank"
				rel="noopener noreferrer"
			>
				{GET_DIRECTIONS}
			</a>
		</div>
	) : null;

	const callButtons = contactInfo.length ? (
		<ul className="tels list-unstyled">
			{contactInfo.map(({ type, number, dept }, index) => {
				const phoneType = type.toUpperCase();
				const callSwappingAttr = {
					'data-phone-ref': phoneType,
					'data-account-ref': accountId
				};
				return (
					<li
						key={phoneType}
						className={`tel phone${index + 1} mb-4`}
						data-click-to-call={dept}
						data-click-to-call-phone={number}
						{...callSwappingAttr}
					>
						<a
							className={callButtonClasses}
							{...callSwappingAttr}
							href={`tel:${number}`}
						>
							{isMobile ? (
								<span>
									{CALL} {dept}
								</span>
							) : (
								<React.Fragment>
									<span>
										{contactInfo.length > 1 ? dept : CALL}{' '}
									</span>
									<span {...callSwappingAttr}>{number}</span>
								</React.Fragment>
							)}
						</a>
					</li>
				);
			})}
		</ul>
	) : null;

	return (
		<React.Fragment>
			{directionButton}
			{callButtons}
		</React.Fragment>
	);
};

export default Cta;

Cta.propTypes = {
	contactInfo: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			number: PropTypes.string.isRequired,
			dept: PropTypes.string.isRequired
		})
	).isRequired,
	mapLink: PropTypes.string.isRequired,
	accountId: PropTypes.string.isRequired,
	ctaPrefs: PropTypes.shape({
		mapButtonStyle: PropTypes.string.isRequired,
		mapButtonSize: PropTypes.string.isRequired,
		mapButtonLayout: PropTypes.string.isRequired,
		callButtonLayout: PropTypes.string.isRequired,
		callButtonStyle: PropTypes.string.isRequired,
		callButtonSize: PropTypes.string.isRequired
	}).isRequired,
	ctaLabels: PropTypes.shape({
		CALL: PropTypes.string.isRequired,
		GET_DIRECTIONS: PropTypes.string.isRequired
	}).isRequired,
	isMobile: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Cta.jsx